<template>
    <rkm-overlay>
        <RecuperarSenha />
    </rkm-overlay>
</template>

<script>
import RecuperarSenha from "@/components/administracao/autenticacao/recuperar-senha/Index"

export default {
    components: { RecuperarSenha },
}
</script>